import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ActivityTimelineComponent } from './activitity/activity-timeline/activity-timeline.component';
import { AccountWizardComponent } from './account/account-wizard/account-wizard.component';
import { AccountDetailComponent } from './account/account-detail/account-detail.component';
import { AccountDashboardComponent } from './account/account-dashboard/account-dashboard.component';
import { AccountArchivedComponent } from './account/account-archived/account-archived.component';

const routes: Routes = [
  { path: '', redirectTo: '/timeline', pathMatch: 'full'},
  { path: 'dashboard', component: AccountDashboardComponent},
  { path: 'timeline', component: ActivityTimelineComponent},
  { path: 'accounts/new', component: AccountWizardComponent},
  { path: 'accounts/archived', component: AccountArchivedComponent},
  { path: 'accounts/:month/:id', component: AccountDetailComponent},
  { path: 'accounts/:id', component: AccountDetailComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
